module.exports = __webpack_public_path__ + "assets/img/social/medium-icon.eb8280629edcea918224c40c74e39c0c.svg";